// VaultCardOptOut.tsx
import React from 'react';
import { FormControlLabel, Checkbox, Typography, Box } from '@mui/material';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { CopyText } from '@acorn-portal/shared/src/components/text';

interface VaultCardOptOutProps {
	checked: boolean;
	onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
	error?: boolean; // Include if you want to handle error styling based on form validation
}

const VaultCardOptOut: React.FC<VaultCardOptOutProps> = ({ checked, onChange, error }) => (
	<Box sx={{ my: 2 }}>
		<CopyText>
			We securely store your payment card details for future payments on your policy. This will enable us to take future
			payments faster without you having to reconfirm your payment details.
		</CopyText>
		<FormControlLabel
			control={
				<Checkbox
					id='vaultCardOptOut'
					name='vaultCardOptOut'
					checked={checked}
					onChange={onChange}
					icon={<CircleOutlinedIcon color={error ? 'error' : undefined} />}
					checkedIcon={<CheckCircle />}
					sx={{
						color: error ? 'error.main' : undefined,
						'&.Mui-checked': {
							color: error ? 'error.main' : undefined,
						},
						'& .MuiSvgIcon-root': { fontSize: '3rem' },
					}}
				/>
			}
			label={
				<Typography variant='body1' sx={{ fontWeight: 'bold' }}>
					I do not wish to take advantage of this feature.
				</Typography>
			}
			labelPlacement='end'
			sx={{
				px: { lg: 3, xs: 0 },
				'.MuiTypography-body1': { fontSize: '1rem' },
			}}
		/>
	</Box>
);

export default VaultCardOptOut;
